import React, { useState, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';

const images = [
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FImages%20Flashcards%20Carrousel%2F1.JPG?alt=media&token=917a459c-4771-45e4-a296-8a212e9a22c6',
    alt: 'Flashcards Notions-Définitions SES Terminale - Vue d\'ensemble'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FImages%20Flashcards%20Carrousel%2F2.JPG?alt=media&token=e314e04a-d603-492e-adad-498da49f478e',
    alt: 'Flashcards Notions-Définitions SES Terminale - Détail des cartes'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FImages%20Flashcards%20Carrousel%2F3.JPG?alt=media&token=9ce0b402-421f-4e3c-a2c1-8399b227b0c7',
    alt: 'Flashcards Notions-Définitions SES Terminale - Organisation par chapitre'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FImages%20Flashcards%20Carrousel%2F4.JPG?alt=media&token=683531ed-6270-4b44-b72f-548e0c9b602a',
    alt: 'Flashcards Notions-Définitions SES Terminale - Exemple de carte'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FImages%20Flashcards%20Carrousel%2F5.JPG?alt=media&token=354c71a5-a35f-4453-8f77-8cb253502e92',
    alt: 'Flashcards Notions-Définitions SES Terminale - Boîte de rangement'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FImages%20Flashcards%20Carrousel%2F6.JPG?alt=media&token=961b14e4-50b1-411b-883e-6529d1375c09',
    alt: 'Flashcards Notions-Définitions SES Terminale - Vue d\'ensemble des cartes'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FImages%20Flashcards%20Carrousel%2F7.JPG?alt=media&token=ea852a87-53d4-432c-b789-d0818d9638f0',
    alt: 'Flashcards Notions-Définitions SES Terminale - Détail du contenu'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFlashcards%20Exemple%2F1.jpg?alt=media&token=436d4c9f-4c85-40c6-b3b8-2c01a6a9b332',
    alt: 'Flashcards Notions-Définitions SES Terminale - Exemple 1'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFlashcards%20Exemple%2F2.jpg?alt=media&token=5d14ffee-9860-4e51-9697-4fc5cea2ff98',
    alt: 'Flashcards Notions-Définitions SES Terminale - Exemple 2'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFlashcards%20Exemple%2F3.jpg?alt=media&token=2fb0dcc3-e800-4e43-b4a7-203d18343ad5',
    alt: 'Flashcards Notions-Définitions SES Terminale - Exemple 3'
  },
  {
    url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFlashcards%20Exemple%2F4.jpg?alt=media&token=d5e11936-d05e-4839-acf6-54930fa29769',
    alt: 'Flashcards Notions-Définitions SES Terminale - Exemple 4'
  }
];

const ProductCarousel = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <div className="relative">
      {/* Carousel principal */}
      <div className="w-full rounded-2xl shadow-2xl overflow-hidden mb-4 [&_.swiper-pagination-bullet]:bg-[#9a6ebd]/50 [&_.swiper-pagination-bullet-active]:bg-[#9a6ebd]">
        <Swiper
          modules={[Navigation, Pagination, Thumbs]}
          navigation={{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next'
          }}
          pagination={{ clickable: true }}
          thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
          loop={true}
          className="h-full"
          onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex)}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index} className="flex justify-center">
              <div className="flex items-center justify-center">
                <img
                  src={image.url}
                  alt={image.alt}
                  className="w-auto h-auto max-w-full max-h-full object-contain"
                  loading={index === 0 ? 'eager' : 'lazy'}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Navigation buttons */}
        <div className="swiper-button-prev !hidden" />
        <div className="swiper-button-next !hidden" />
        
        <button 
          className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/80 rounded-full flex items-center justify-center text-[#323c5f] hover:bg-white z-10"
          onClick={() => {
            const swiper = document.querySelector('.swiper')?.swiper;
            if (swiper) swiper.slidePrev();
          }}
        >
          <ChevronLeft size={24} />
        </button>
        <button 
          className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/80 rounded-full flex items-center justify-center text-[#323c5f] hover:bg-white z-10"
          onClick={() => {
            const swiper = document.querySelector('.swiper')?.swiper;
            if (swiper) swiper.slideNext();
          }}
        >
          <ChevronRight size={24} />
        </button>
      </div>

      {/* Carrousel de vignettes */}
      <div className="w-full">
        <Swiper
          modules={[Navigation, Thumbs]}
          onSwiper={setThumbsSwiper}
          spaceBetween={8}
          slidesPerView={4}
          breakpoints={{
            640: {
              slidesPerView: 5,
              spaceBetween: 10
            },
            768: {
              slidesPerView: 6,
              spaceBetween: 12
            },
            1024: {
              slidesPerView: 7,
              spaceBetween: 12
            }
          }}
          watchSlidesProgress={true}
          className="thumbnails-swiper"
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <div 
                className={`relative cursor-pointer rounded-lg overflow-hidden transition-all duration-200 ${
                  currentIndex === index 
                    ? 'ring-2 ring-[#9a6ebd] ring-offset-2 shadow-lg' 
                    : 'hover:ring-2 hover:ring-[#9a6ebd]/50 hover:ring-offset-1'
                }`}
              >
                <img
                  src={image.url}
                  alt={image.alt}
                  className="w-full h-16 sm:h-20 object-cover"
                  loading="lazy"
                />
                {/* Overlay pour l'image active */}
                {currentIndex === index && (
                  <div className="absolute inset-0 bg-[#9a6ebd]/10 border-2 border-[#9a6ebd] rounded-lg"></div>
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default ProductCarousel;